export default __webpack_public_path__ + "static/team_pete-9e7090e9420c24204f736fc4cae5f971.png";